// `Model` from its own module, not the `@/models` barrel — see the note in `index.ts`.
import { Model } from './model';
import { type EntryUpdateReason } from '@/models';
import { DateTime } from 'luxon';

export interface ActivityResponse {
  activities: ActivityModel[],
  activityCount: number,
}

export interface NetworkActivity {
  activityOwner: {
    email: string;
    identifier: string;
    name: string;
  }
  createdAt: string;
  difference: {
    initialValues: NewValues
    newValues: NewValues
  }
  identifier: string;
  investigationIdentifier: string;
  organizationIdentifier: string;
  organizationOwner: {
    email: string;
    identifier: string;
    name: string;
  }
  subType: string;
  type: string;
  typeIdentifier: string;
  updatedAt: Date;
}

interface IActivity {
  activityOwner: {
    email: string;
    identifier: string;
    name: string;
  }
  difference: {
    newValues?: NewValues
  }
  createdAt: Date;
  subType: string;
  type: string;
  identifier: string;
}

interface NewValues {
  email: string;
  title: string;
  label: string;
  name: string;
  reasons: EntryUpdateReason;
}

export class ActivityModel extends Model {
  activityOwner: {
    email: string;
    identifier: string;
    name: string;
  };
  createdAt: Date;
  difference: {
    initialValues?: NewValues
    newValues?: NewValues
  };
  subType: string;
  type: string;
  identifier: string;

  constructor({
    activityOwner,
    createdAt,
    difference,
    subType,
    type,
    identifier
  }: IActivity) {
    super();
    this.activityOwner = activityOwner;
    this.createdAt = createdAt;
    this.difference = difference;
    this.subType = subType;
    this.type = type;
    this.identifier = identifier;
  }

  static mapFromBackend(networkActivity: NetworkActivity): ActivityModel {
    const simplifiedActivity: IActivity = {
      activityOwner: networkActivity.activityOwner,
      createdAt: DateTime.fromISO(networkActivity.createdAt).toJSDate(),
      difference: networkActivity.difference,
      subType: networkActivity.subType,
      type: networkActivity.type,
      identifier: networkActivity.identifier
    };
    return new ActivityModel(simplifiedActivity);
  }
}
